class BhumiDetailViewer extends HTMLElement {
  connectedCallback() {
    this.exploreLabel=this.dataset.exploreLabel;
    this.resetLabel=this.dataset.resetLabel;
    this.image=this.querySelector('[data-detail-image]');
    this.stage=this.querySelector('[data-detail-stage]');
    this.zoom=this.querySelector('[data-detail-zoom]');
    this.media=JSON.parse(this.querySelector('[data-detail-variants]').textContent);
    this.thumbnails=this.querySelector('[data-detail-thumbnails]');
    this.views=JSON.parse(this.querySelector('[data-detail-gallery]')?.textContent||'[]');
    this.zoom.addEventListener('click',()=>{const on=this.zoom.getAttribute('aria-pressed')!=='true';this.zoom.setAttribute('aria-pressed',String(on));this.zoom.textContent=on?this.resetLabel:this.exploreLabel;this.stage.classList.toggle('is-zoomed',on);});
    this.stage.addEventListener('pointermove',e=>{const r=this.stage.getBoundingClientRect();this.image.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';});
    this.showViews(this.dataset.metalTone);
    this.subscription=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{
      if(!data.variant)return;
      const sourceProduct=data.html?.querySelector('product-info[data-product-id]');
      if(sourceProduct&&sourceProduct.dataset.productId!==this.dataset.productId)return;
      const featured=data.variant.featured_media?.preview_image||data.variant.featured_image;
      const source=this.media[data.variant.id]||(typeof featured==='string'?featured:featured?.src);
      if(!source)return;
      this.setImage(source,this.dataset.productTitle+' - '+data.variant.options.join(' / '));
      const tone=data.variant.options.find(value=>/^(White|Yellow|Rose)$/i.test(value));
      this.showViews(tone);
    });
  }
  setImage(source,alt) {
    const src=new URL(source,window.location.origin);src.searchParams.set('width','1254');
    this.image.src=src.href;this.image.removeAttribute('srcset');this.image.alt=alt;
    this.zoom.setAttribute('aria-pressed','false');this.zoom.textContent=this.exploreLabel;
    this.stage.classList.remove('is-zoomed');this.image.style.transformOrigin='50% 50%';
  }
  toneOf(alt){return alt?.match(/(?:-|\u2013|\u2014)\s*(White|Yellow|Rose)\s+metal\b/i)?.[1]?.toLowerCase();}
  showViews(tone) {
    const selected=String(tone||'').toLowerCase();
    if(!selected||!this.views.length||!this.thumbnails)return;
    const matches=this.views.filter(view=>this.toneOf(view.alt)===selected);
    if(!matches.length){this.thumbnails.replaceChildren();return;}
    this.thumbnails.replaceChildren();
    for(const [index,view] of matches.entries()){
      const button=document.createElement('button');button.type='button';button.className='bhumi-detail__view';
      button.setAttribute('aria-label',view.alt);button.setAttribute('aria-pressed',String(index===0));
      const photo=document.createElement('img'),src=new URL(view.src,window.location.origin);src.searchParams.set('width','200');
      photo.src=src.href;photo.alt='';photo.loading='lazy';photo.width=100;photo.height=100;button.append(photo);
      button.addEventListener('click',()=>{this.setImage(view.src,view.alt);for(const other of this.thumbnails.children)other.setAttribute('aria-pressed',String(other===button));});
      this.thumbnails.append(button);
    }
    this.filterNativeGallery(selected);
  }
  filterNativeGallery(tone) {
    if(typeof document==='undefined')return;
    const product=[...document.querySelectorAll('product-info[data-product-id]')].find(item=>item.dataset.productId===this.dataset.productId);
    const gallery=product?.querySelector('media-gallery');
    if(!gallery)return;
    for(const item of gallery.querySelectorAll('li[data-media-id], li[data-target]')){
      const itemTone=this.toneOf(item.querySelector('img')?.alt);if(!itemTone)continue;
      if(itemTone!==tone){item.style.setProperty('display','none','important');item.dataset.bhumiToneHidden='true';}
      else {item.style.removeProperty('display');delete item.dataset.bhumiToneHidden;}
    }
    for(const slider of gallery.querySelectorAll('slider-component'))slider.initPages?.();
  }
  disconnectedCallback(){if(this.subscription)this.subscription();}
}
if(!customElements.get('bhumi-detail-viewer'))customElements.define('bhumi-detail-viewer',BhumiDetailViewer);

